import { request } from "@/http";

export const readNotification = (id:number) => request({
    url: `/notifications/${id}/check`,
    method: 'POST'
});